<template>

    <div class="user-equity-chat-dashboard">
        <loader v-if="pageLoader"></loader>
        <div
            class="h-100"
            v-show="(Object.keys(userEquityChartWithLeader).length && userEquityChartWithLeader.series.length && userEquityChartWithLeader.series[0].data.length)">
            <div id="profit_chart_history" class="profit_leader"></div>

        </div>
        <!-- <div class="d-flex justify-content-between align-items-center">
            <div class="wt-dashborad-chart-footer mt-3 mb-2 ">
                <ul class="d-flex align-items-center p-0">
                    <li v-for="item,key in dateDrop" @click.prevent.stop="dateDropSelected = key" :class="{'active':dateDropSelected == key}">{{ item }}</li>
                </ul>
            </div>
        </div> -->
    </div>
</template>

<script>
import { commonAllmixins } from "@/plugins/commonAll";
import * as am4core from "../../../../../../node_modules/@amcharts/amcharts4/core"
import * as am4charts from "../../../../../../node_modules/@amcharts/amcharts4/charts"
import am4themes_animated from "../../../../../../node_modules/@amcharts/amcharts4/themes/animated"

export default {
    emits: ['callApiHit'],
    props: ['providerId','timeFrame'],
    mixins: [commonAllmixins],
    mounted() {
        this.drawLeaderProfitChart()
    },

    data: function () {
        return {
            pageLoader: false
        }
    },

    watch: {
        providerId() {
            if (this.providerId) {
                this.drawLeaderProfitChart();
            }
        },
        timeFrame() {
            if (this.timeFrame) {
                this.drawLeaderProfitChart();
            }
        },
    },

    methods: {
        getData() {
            this.$emit('callApiHit', true);
        },
        drawLeaderProfitChart() {
            // Destroy existing chart instance if any
            try {
                // Destroy existing chart instance if any
                this.destroyChart();

                // Create chart instance
                let chart = am4core.create("profit_chart_history", am4charts.XYChart);

                // Set themes
                am4core.useTheme(am4themes_animated);

                // Date and number formatting
                chart.dateFormatter.dateFormat = "dd-yyyy";
                chart.dateFormatter.inputDateFormat = "yyyy-MM-dd"; // Example format
                chart.numberFormatter.numberFormat = "#.##";

                // Set chart properties
                chart.paddingLeft = 0;
                chart.paddingRight = 0;
                chart.panX = false;
                chart.panY = false;
                chart.wheelX = "panX";
                chart.wheelY = "zoomX";
                chart.pinchZoomX = false;

                // Create axes
                let xAxis = chart.xAxes.push(new am4charts.DateAxis());
                xAxis.renderer.grid.template.disabled = true;
                xAxis.groupData = true;
                xAxis.baseInterval = {
                    timeUnit: "day",
                    count: 1
                };
                xAxis.renderer.minGridDistance = 50;
                xAxis.dateFormats.setKey("day", "MM/dd");
                xAxis.periodChangeDateFormats.setKey("day", "MMMM");

                let yAxis = chart.yAxes.push(new am4charts.ValueAxis());
                // yAxis.renderer.grid.template.stroke = am4core.color(0x666666);
                yAxis.renderer.grid.template.strokeWidth = 1;
                yAxis.renderer.grid.template.stroke = am4core.color("#7c8084"); // Light gray color for grid

                //to disable tooltip over xaxis and yaxis
                xAxis.cursorTooltipEnabled = false;
                yAxis.cursorTooltipEnabled = false;
                // Set chart colors based on the data
                if (this.userEquityChartWithLeader.series.forEach.length > 1) {
                    chart.colors.list = [
                        am4core.color("#079C77"),
                        am4core.color("#079C77"),
                    ];
                } else {
                    chart.colors.list = [
                        am4core.color("#079C77"),
                    ];
                }

                // // Add legend
                // chart.legend = new am4charts.Legend();
                // chart.legend.position = "bottom";
                // chart.legend.labels.template.fontSize = 12;
                // chart.legend.labels.template.fontWeight = "600";
                // chart.legend.markers.template.width = 13;
                // chart.legend.markers.template.height = 13;

                // Add series
                this.userEquityChartWithLeader.series.forEach(key => {
                    let series = chart.series.push(new am4charts.LineSeries());
                    series.name = 'Profit';
                    series.dataFields.valueY = "y";
                    series.dataFields.dateX = "x";
                    series.tooltipText = "Profit : {valueY}";
                    series.strokeWidth = 2;
                    series.fillOpacity = 0.1;

                    // // Set gradient fill
                    // let gradient = new am4core.LinearGradient();
                    // gradient.addColor(am4core.color(0xff7200), 0.7);
                    // gradient.addColor(am4core.color(0xff7200), 0.1);
                    // series.fill = gradient;

                    // Set data
                    series.data = key.data;

                    // Enable animation on load
                    series.hiddenState.properties.opacity = 0;
                    series.defaultState.transitionDuration = 1000;
                });

                // Add cursor
                chart.cursor = new am4charts.XYCursor();
                chart.cursor.lineY.disabled = true;
                chart.cursor.lineX.disabled = true;

                // Set axis labels
                xAxis.renderer.labels.template.fill = am4core.color("#666666");
                xAxis.renderer.labels.template.fontSize = 10;

                yAxis.renderer.labels.template.fill = am4core.color("#666666");
                yAxis.renderer.labels.template.fontSize = 12;

                // Animate chart on load
                chart.hiddenState.properties.opacity = 0;
                chart.defaultState.transitionDuration = 1000;
            }
            catch (error) {
                console.log(error);
            }
        },


        setTimeframe: function (dateDrop) {
            this.dateDropSelected = dateDrop;
            this.getData();
        },
        destroyChart() {
            let chartElement = am4core.registry.baseSprites.find((sprite) => sprite.htmlContainer.id === "profit_chart_history");
            if (chartElement) {
                chartElement.dispose();
            }
        },
    }
}
</script>
<style>
.profit_leader {
    height: 500px;
    width: 100%;
    display: 'block';
}
</style>


// WEBPACK FOOTER //
// src/components/website/copy-trade/leader-detail/Charts/userEquityChartWithLeader.vue